<template>
  <v-btn
    color="primary"
    :class="$vuetify.breakpoint.mdAndUp ? 'btn-desktop' : 'btn-mobile'"
    data-cy="btn_enviar"
    :disabled="desabilitarBtn"
    :loading="botaoLoading"
    @click="salvarDados()"
  >
    Salvar
  </v-btn>
</template>

<script>
import api from '@/api';

export default {
  name: 'BtnSalvar',

  props: {
    desabilitarBtn: {
      type: Boolean,
      required: true,
    },
    dadosConta: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      botaoLoading: false,
      urlApi: '/bank-account',
    };
  },

  methods: {
    salvarDados() {
      const formData = {};
      this.botaoLoading = true;

      formData.full_name = this.dadosConta.nomeFavorecido;
      formData.federal_tax_number = this.removeCaracter(this.dadosConta.fieldCpfCnpj);
      formData.bank_code = this.dadosConta.bankCode;
      formData.account_type = this.dadosConta.tipoConta;
      formData.bank_branch = this.tratarValorNulo(this.dadosConta.agencyNumber);
      formData.bank_branch_suffix = this.tratarValorNulo(this.dadosConta.agencyCheckNumber);
      formData.account_number = this.tratarValorNulo(this.dadosConta.accountNumber);
      formData.account_number_suffix = this.tratarValorNulo(this.dadosConta.accountCheckNumber);
      formData.operation_type = this.tratarValorNulo(this.dadosConta.operacaoVariacao);
      formData.accepted_terms = this.dadosConta.accepted_terms ? 1 : 0;

      api.post(this.urlApi, formData)
        .then(() => {
          this.$emit('respostaApi', true);
        })
        .catch((error) => {
          const { data } = error.response;
          const errorMessage = data.show ? data.error : 'Tente novamente mais tarde.';
          this.$emit('respostaApi', false, errorMessage);
        })
        .finally(() => {
          this.botaoLoading = false;
        });
    },

    tratarValorNulo(value) {
      return value == null ? '' : value;
    },

    removeCaracter(value) {
      if (!value) return '';

      return value.replace(/[.\-/]/g, '').toUpperCase();
    },
  },
};
</script>
